import React from 'react';

/**
 * Generic Empty State Component
 * Displays a centered icon, title, description, and optional action.
 */
const EmptyState = ({
    icon: Icon,
    title,
    description,
    action,
    className = ""
}) => {
    return (
        <div className={`flex flex-col items-center justify-center p-8 text-center h-full animate-fadeIn ${className}`}>
            {Icon && (
                <div className="w-16 h-16 bg-gray-100 dark:bg-gray-800 text-gray-400 dark:text-gray-500 rounded-full flex items-center justify-center mb-4">
                    <Icon size={32} />
                </div>
            )}

            {title && (
                <h3 className="text-gray-900 dark:text-white font-bold text-lg mb-2">
                    {title}
                </h3>
            )}

            {description && (
                <p className="text-gray-500 dark:text-gray-400 max-w-sm text-sm mb-6 leading-relaxed">
                    {description}
                </p>
            )}

            {action && (
                <div className="mt-2">
                    {action}
                </div>
            )}
        </div>
    );
};

export default EmptyState;
